module.exports = __webpack_public_path__ + "static/media/0044.e7547802.svg";